import { useState } from "react";
import { FetchStatus } from "cy-models";

export function useFetchState() {
  const [status, setStatus] = useState<FetchStatus>();
  const [data, setData] = useState<any>();
  const [error, setError] = useState<any>();

  async function doFetch(fn: any) {
    try {
      setData(undefined);
      setError(undefined);
      setStatus("fetching");
      const result = await fn();
      setData(result);
      setStatus("fetched");
    } catch (err) {
      setError(err);
      setStatus("error");
    }
  }
  return { status, data, error, doFetch };
}
